#!/usr/bin/env node

/** @albertli/al-cli v0.70.2
*
*   This source code is licensed under the MIT license found in the
*   LICENSE file in the root directory of this source tree.
*
**/

import handlebars from 'handlebars';

const importHelper = require('handlebars-helper-import')(handlebars);

handlebars.registerHelper('import', importHelper);

import cli from './meow';

import generatorDict from './generator';

import { doGenerateOne } from './util';

const commands = cli.input;

if (commands.length > 0 && commands[0] !== 'help' && generatorDict[commands[0]] ){
    doGenerateOne(generatorDict[commands[0]].generator());
}else{
    cli.showHelp();
}
